import { IClasse } from './classe.model';
import { IEcole } from './ecole.model';

export interface IDestinataire {
  id?: string;
  classes?: IClasse[] | null;
  ecole?: IEcole | null;
  statutPresence?: string;
  etatPaiement?: string;
  message?: string | null;
  createdDate?: string | null;
  eleveMatricule?: string | null;
  page?: number | null;
  size?: number | null;
}
export const defaultValue: Readonly<IDestinataire> = {
  id: null,
  classes: null,
  ecole: null,
  etatPaiement: '',
  statutPresence: '',
  message: '',
  eleveMatricule: null,
  createdDate: null,
  page: 0,
  size: 0,
};
